import React from 'react';
import TripDetailsSubHeading from '../../../tripDetailsSubHeading/TripDetailsSubHeading';

const GuidePrice = ({ data }) => {
    return (
        <div>
            {Array.isArray(data) &&
                data.length > 0 &&
                data.map((item, index) => {
                    return (
                        <div className='priceDetailsContainer'>
                            <TripDetailsSubHeading text={item.name || `Place ${index + 1}`} />
                            <div className='priceDetailsDiv'>
                                <span className='priceDetailsSpan'>
                                    <strong>Actual: </strong>
                                    &#8377;{item.actual}
                                </span>
                                <span className='priceDetailsSpan'>
                                    <strong>Tax: </strong>
                                    &#8377;{item.tax}
                                </span>
                                <span className='priceDetailsSpan'>
                                    <strong>Total: </strong>
                                    &#8377;{item.total}
                                </span>
                                <span className='priceDetailsSpan'>
                                    <strong>Reserve: </strong>
                                    &#8377;{item.reserve}
                                </span>
                                {item.higherPrice && (
                                    <span className='priceDetailsSpan'>
                                        <strong>Higher Price : </strong>
                                        &#8377;{item.higherPrice}
                                    </span>
                                )}
                                {item.discountPrice && (
                                    <span className='priceDetailsSpan'>
                                        <strong>Discount Per Price : </strong>
                                        &#8377;{item.discountPrice}
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

export default GuidePrice;
